"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyWithNumber = void 0;
var core_money_1 = require("@newfront-insurance/core-money");
var core_ui_1 = require("@newfront-insurance/core-ui");
var get_1 = __importDefault(require("lodash/get"));
var react_1 = __importDefault(require("react"));
function CurrencyWithNumber(props) {
    var onChange = props.onChange, name = props.name, value = props.value, currencyFieldLabel = props.currencyFieldLabel, currencyFieldName = props.currencyFieldName, numberFieldLabel = props.numberFieldLabel, numberFieldName = props.numberFieldName, decimalScale = props.decimalScale, appendText = props.appendText;
    function handleChange(newValue) {
        var _a;
        var currencyValue = newValue === null || newValue === void 0 ? void 0 : newValue[currencyFieldName];
        var numberValue = newValue === null || newValue === void 0 ? void 0 : newValue[numberFieldName];
        if (!currencyValue && !numberValue) {
            onChange(undefined);
            return;
        }
        onChange((_a = {},
            _a[currencyFieldName] = currencyValue,
            _a[numberFieldName] = numberValue,
            _a));
    }
    return (react_1.default.createElement(core_ui_1.Flexbox, { gap: 16, flexDirection: "row" },
        react_1.default.createElement(core_ui_1.Field, { label: currencyFieldLabel || '', fieldId: name + "." + currencyFieldName },
            react_1.default.createElement(core_ui_1.CurrencyInput, { name: name + "." + currencyFieldName, value: (0, core_money_1.toNumberOrUndefinedFromMoney)((0, get_1.default)(value, currencyFieldName)), decimalScale: decimalScale, onChange: function (inputValue) {
                    var _a;
                    return handleChange(__assign(__assign({}, value), (_a = {}, _a[currencyFieldName] = (0, core_money_1.toMoneyOrUndefined)(inputValue), _a)));
                } })),
        react_1.default.createElement(core_ui_1.Field, { label: numberFieldLabel || '', fieldId: name + "." + numberFieldName },
            react_1.default.createElement(core_ui_1.Input, { type: "number", value: (0, get_1.default)(value, numberFieldName) || '', onChange: function (inputValue) {
                    var _a;
                    var newNumberValue = inputValue ? Number(inputValue) : undefined;
                    handleChange(__assign(__assign({}, value), (_a = {}, _a[numberFieldName] = newNumberValue, _a)));
                }, appendText: appendText }))));
}
exports.CurrencyWithNumber = CurrencyWithNumber;
